import { useLegalProceedingsDetail } from './hook';
import { LayoutModule } from '../../../../layout/modules';
import FeedIcon from '@mui/icons-material/Feed';
import { LegalProceedingsDetailActions } from './actions';
import { LegalProceedingsProcessData } from './processData';
import { LegalProceedingsRegisterHistory } from './registerHistory';
import { LegalProceedingsHistorical } from './historical';
import { LegalProceedingsAttachment } from './attachments';
import { useSelector } from 'react-redux';
import { RootState } from '../../../../../redux/store';
import { isTrainerOrQuality } from '../../../../../shared/types/profiles';

export const LegalProceedingsDetail = () => {
    const { logUser } = useSelector((state: RootState) => state.general);
    const { type } = logUser || {};
    const { legalProceeding, loading, legalProceedingHistorical } =
        useLegalProceedingsDetail();

    const additionalButtons = !isTrainerOrQuality(type) ? (
        <LegalProceedingsDetailActions
            legalProceedingId={legalProceeding?.id || ''}
        />
    ) : undefined;

    return (
        <>
            <LayoutModule
                title="Detalle caso proceso judicial"
                titleChildren="Detalle información general"
                icon={<FeedIcon sx={{ color: 'primary.main' }} />}
                additionalButtons={additionalButtons}
            >
                <LegalProceedingsProcessData
                    legalProceeding={legalProceeding}
                    loading={loading}
                />
            </LayoutModule>
            <LegalProceedingsRegisterHistory
                legalProceeding={legalProceeding}
            />

            <LegalProceedingsHistorical
                historical={legalProceedingHistorical ?? []}
            />
            <LegalProceedingsAttachment
                attachment={legalProceeding?.attachments || []}
            />
        </>
    );
};
